import { render } from "./TriplePicture.vue?vue&type=template&id=9c2e1ee4"
import script from "./TriplePicture.vue?vue&type=script&lang=js"
export * from "./TriplePicture.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__